// App.js
import React from 'react';
import './assets/scss/themes.scss';
import Route from './Routes';
import { Provider } from 'react-redux';
import store from './store';
import { PocketBaseProvider, pb } from './PocketBaseContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Provider store={store}>
      <PocketBaseProvider>
        <React.Fragment>
          <Route />
          <ToastContainer autoClose={2000} limit={1} />
        </React.Fragment>
      </PocketBaseProvider>
    </Provider>
  );
}

export default App;
export { pb };